import React from 'react';
import PropTypes from 'prop-types';

function ServiceItem (props) {
  return (
    <div key={props.index} className='service-block' >
      <div className={'icon-service ' + props.imageSrc}>&nbsp;</div>
      <h3 className='service-title'>{props.textTitle}</h3>
      <p className='service-text'>{props.text}</p>
      <a className='btn-base btn-primary btn-service-link' href={props.buttonLink} target='_blank'>
        {props.buttonText}
      </a>
    </div>
  );
}

ServiceItem.propTypes = {
  index: PropTypes.number.isRequired,
  imageSrc: PropTypes.string.isRequired,
  textTitle: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};

export default ServiceItem;



// WEBPACK FOOTER //
// ./src/ui/Menu/ServiceItem.jsx